import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  item: any;
  color: string;
  onTagSelect: any;
}

const Tag = ({ item, color, onTagSelect }: Props) => {
  return (
    <StyledTag color={color} selected={item?.selected} onClick={()=>onTagSelect(item)}>
      {item.label}
    </StyledTag>
  );
};

interface TagStatusProps {
  selected: boolean;
  color: string;
}

const StyledTag = styled.div<TagStatusProps>`
  padding: 0.25rem 1rem;
  font-size: 0.9rem;
  background: ${(props) => (props.selected === true ? props.color : "#CCC")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2rem;
  color: ${Colors.white};
  font-family: Poppins-Medium;
  width: fit-content;
  border: 1px solid
    ${(props) => (props.selected === true ? props.color : "#CCC")};
`;

export default Tag;
